import React, {Component} from 'react';
import {appConstants} from "../../_constants";
import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
} from "@material-ui/core";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import Tooltip from '@material-ui/core/Tooltip';
import {PrimaryLabel, DefaultLabel} from "../../utils/LabelPanel"
import {commonService} from "../../_services";
import {alertActions} from "../../_actions";
import {connect} from "react-redux";
import ViewAirlineRoutes from "./ViewAirlineRoutes";
import Modal from "../../utils/Modal";


const customModalStyle = {
    width: '75%',
    maxWidth: 'none',
    overflow: 'scroll'
};

const TableStructure = ({classes, records, handleViewRouteModal}) => (
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead className={classes.negativeColor} color="regional">
            <TableRow>
                <TableCell>S/N</TableCell>
                <TableCell>Airline</TableCell>
                <TableCell>Airline Code</TableCell>
                <TableCell>AIN</TableCell>
                <TableCell>Pull Manifest</TableCell>
                {/* <TableCell>Is Regional</TableCell> */}
                <TableCell>Actions</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {records.map((item, key) => {
                return (
                    <TableRow hover key={key}>
                        <TableCell>{key + 1}</TableCell>
                        <TableCell className={'text-capitalize'}>{item.Airline}</TableCell>
                        <TableCell className={'text-capitalize'}>{item.AirlineCode}</TableCell>
                        <TableCell className={'text-capitalize'}>{item.CustomerAin}</TableCell>
                        <TableCell>
                            {
                                item.IsPullManifest &&
                                <PrimaryLabel message={'Yes'}/>
                            }
                            {
                                !item.IsPullManifest &&
                                <DefaultLabel message={'No'}/>
                            }
                        </TableCell>
                         {/* <TableCell>
                            {
                                item.IsRegional &&
                                <PrimaryLabel message={'Yes'}/>
                            }
                            {
                                !item.IsRegional &&
                                <DefaultLabel message={'No'}/>
                            }
                        </TableCell> */}
                        <TableCell>
                             <span style={{ cursor: "pointer" }} onClick={() => handleViewRouteModal(item)}>
                                 <Tooltip title="View" placement="top">
                                         <span className={classes.icon}><ViewIcon /></span>
                                     </Tooltip>
                             </span>
                        </TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    </Table>
);
class AirlineRoutes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            routes: [],
            currentAirline: false,
            From: 1,
            Size: 10,
            TotalCount: 0,
            viewModal: false,
            airlines: []
        }
    }

    componentDidMount() {
        this.getAllAirlines();
    }

    getAllAirlines = () => {
        const { dispatch } = this.props;
        commonService.getAllAirlinesRegional()
            .then(res => {
                let response = res.response;
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        airlines: response
                    });
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                }
            }).catch(err => {

        })
    };

    openAirlineRoutes =(item) => {
        this.setState({
            routes: item.AirlineRoutes,
            viewModal: true,
            currentAirline: item
        });
    };
    handleViewRouteModal = () =>{
        this.setState(prevState => ({
                viewModal : !prevState.viewModal
            }
        ))
    };
    fetchPageAirlineRoute = (pageNumber = 1) => {
        const { dispatch } = this.props;
        const { Size, currentAirline } = this.state;
        const payload = {
            AirlineId: currentAirline.AirlineId,
            Size,
            From: pageNumber
        };
        dispatch(alertActions.startRequest());
        commonService.searchAirlineRouteRegional(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        TotalCount: response.TotalCount,
                        routes: response.AirlineRoute,
                        viewModal: true,
                        From: pageNumber
                    })
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                }
            });
    };

    render() {
        const { classes } =  this.props;
        const { airlines, routes, currentAirline, viewModal } =  this.state;
        return (
            <div>
                {/* Route View*/}
                <Modal
                    title={false}
                    content={
                        <ViewAirlineRoutes
                            routes={routes}
                            airline={currentAirline}
                        />
                    }
                    modalStatus={viewModal}
                    handleClose={this.handleViewRouteModal}
                    modalStyle={customModalStyle}
                />

                {
                    (airlines.length > 0) &&
                    <TableStructure
                        handleViewRouteModal={this.openAirlineRoutes}
                        classes={classes}
                        records={airlines}
                    />
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { alert, requesting, progress} = state;
    return {
        alert,
        progress,
        requesting,
    };
}
export default connect(mapStateToProps)(AirlineRoutes);



// WEBPACK FOOTER //
// ./src/Regional-Views/AirlineRouteSettings/AirlineRoute.js